<template>
  <div class="email-temp-main">
    <CRow>
      <CCol sm="12">
        <!-- ---------------------- -->
        <CCard>
          <CCardHeader>
            <strong class="cemail-main-head flex fs-16 fw-500 col-fonts-grey">
              <CIcon
                class="cemail-icon mr-3"
                name="cil-envelope-closed"
                size="lg"
              />
              Email Templates
            </strong>
            <div class="cright-side-select-wrap flex">
              <!-- <CSwitch
                class="mr-4"
                :key="key"
                :color="colors"
                v-bind="modes"
                checked
                :value="color"
                v-for="(color, key) in colors"
              /> -->
              <!-- <CSelect
                :options="[
                  'Waste Module',
                  'Attendance Module',
                  'Marketing Dashboard',
                  'Market Planning',
                  'Feedback module',
                ]"
                @change="onChangeModule($event)"
              /> -->
            </div>
          </CCardHeader>
          <CCardBody>
            <div
              class="c-accordion"
              data-individual-openable="true"
              data-speed="200"
            >
              <div class="c-accordion__entries">
                <div
                  class="c-accordion__entry"
                  aria-expanded="false"
                  role="tablist"
                  v-for="(item, index) in emailItems"
                  :key="index"
                >
                  <div
                    :id="'c-accordion__entry-title-' + parseInt(index + 1)"
                    class="c-accordion__entry-title"
                    aria-selected="false"
                    :aria-controls="
                      'c-accordion__entry-body-' + parseInt(index + 1)
                    "
                    role="tab"
                  >
                    <div v-if="item.Status == true">
                      <CSwitch
                        class="ml-3"
                        :key="key"
                        :color="colors"
                        v-bind="modes"
                        checked
                        :value="color"
                        v-for="(color, key) in colors"
                        @change.native="
                          enableDisableEmailTemplate(
                            $event,
                            item.EmailTemplateId,
                            item.ModuleId
                          )
                        "
                      />
                    </div>
                    <div v-else>
                      <CSwitch
                        class="ml-3"
                        :key="key"
                        :color="colors"
                        v-bind="modes"
                        unchecked
                        :value="color"
                        v-for="(color, key) in colors"
                        @change.native="
                          enableDisableEmailTemplate(
                            $event,
                            item.EmailTemplateId,
                            item.ModuleId
                          )
                        "
                      />
                    </div>
                    <a
                      href="#"
                      @click="onHideShow(index + 1)"
                      class="
                        smaller
                        c-accordion__entry-header-link
                        js-accordion__entry-header-link
                      "
                    >
                      {{ item.ModuleName }}
                      <div class="c-accordion__entry-header-icon-wrapper">
                        <svg
                          class="c-accordion__entry-header-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="19.999"
                          height="12.979"
                          viewBox="0 0 19.999 12.979"
                        >
                          <path
                            d="M12,14.979l-10-10L4.979,2,12,9.021,19.02,2,22,4.979Z"
                            transform="translate(-2 -2)"
                            fill="#000"
                          ></path>
                        </svg>
                      </div>
                    </a>
                  </div>
                  <!-- @input="dateFilter_client" -->
                  <!--<CForm>
                    <CRow
                      class="mx-2"
                      style="margin-top: 20px; width: 100%; margin-left: 2px"
                    >
                      <CCol class="px-0" col="6">
                        <CFormLabel
                          for="emailsubjectline"
                          style="font-size: 1.125em;color: #3c4b64;"
                          >Email Subject Line</CFormLabel
                        >
                        <textarea
                          placeholder="Email Subject Line"
                          name="EmailSubjectLine"
                          type="text"
                          class="form-control"
                          :value="item.EmailSubjectLine"
                          :id="'EmailSubjectLine_' + index"
                        >
                        </textarea>
                      </CCol>
                      <CCol col="6">
                        <CFormLabel
                          for="toemailaddress"
                          style="font-size: 1.125em;color: #3c4b64;"
                          >To Email Address</CFormLabel
                        >
                        <textarea
                          type="text"
                          placeholder="To Email Address"
                          name="ToEmailAddress"
                          class="form-control"
                          :value="item.ToEmailAddress"
                          :id="'ToEmailAddress_' + index"
                        >
                        </textarea>
                      </CCol>
                    </CRow>
                  </CForm> -->
                  <!--  -->
                  <div
                    :id="'c-accordion__entry-body-' + parseInt(index + 1)"
                    class="c-accordion__entry-body"
                    aria-hidden="true"
                    role="tabpanel"
                    :aria-labelledby="
                      'c-accordion__entry-title-' + parseInt(index + 1)
                    "
                    style="display: none"
                  >
                    <div class="c-accordion__entry-contents p-2 c-wysiwyg">
                      <CForm class="mb-2">
                        <CRow
                          style="
                            margin-top: 20px;
                            width: 100%;
                            margin-left: 2px;
                          "
                        >
                          <CCol class="px-0" col="6">
                            <CFormLabel
                              for="emailsubjectline"
                              style="font-size: 1.125em; color: #3c4b64"
                              >Email Subject Line</CFormLabel
                            >
                            <textarea
                              placeholder="Email Subject Line"
                              name="EmailSubjectLine"
                              type="text"
                              class="form-control"
                              :value="item.EmailSubjectLine"
                              :id="'EmailSubjectLine_' + index"
                            >
                            </textarea>
                          </CCol>
                          <CCol col="6">
                            <CFormLabel
                              for="toemailaddress"
                              style="font-size: 1.125em; color: #3c4b64"
                              >To Email Address</CFormLabel
                            >
                            <textarea
                              type="text"
                              placeholder="To Email Address"
                              name="ToEmailAddress"
                              class="form-control"
                              :value="item.ToEmailAddress"
                              :id="'ToEmailAddress_' + index"
                            >
                            </textarea>
                          </CCol>
                        </CRow>
                      </CForm>
                      <CRow>
                        <CCol col="9">
                          <!-- <p class="border rounded p-1" v-html="item.MailBody"> -->
                          <!-- <html>
                              <head>
                              <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
                              <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
                              <title>Subject: {{Waste_name}} on {{Added_date}}</title>
                              <link href="https://fonts.googleapis.com/css?family=Montserrat" rel="stylesheet">
                              </head>
                              <body>		
                              <div style="margin: 0;padding: 0;font-family: Helvetica Neue, Helvetica, Helvetica, Arial, sans-serif;font-size: 100%;line-height: 1.6;box-sizing: border-box;">	
                              <div style="display: block !important;max-width: 600px !important;margin: 0 auto !important;clear: both !important;">
                              </body>
                              </html> {{ item.MailBody }}-->
                          <!-- </p> :id="index+ '_mailArea'"-->
                          <!-- :id="'mailArea_' + index" -->
                          <CFormLabel
                            for="mailbody"
                            style="font-size: 1.125em; color: #3c4b64"
                            >Mail Body</CFormLabel
                          >

                          <CTextarea
                            :id="'mailArea_' + index"
                            rows="15"
                            :value="item.MailBody"
                          >
                          </CTextarea>
                          <div class="btn-bottom-wrap flex">
                            <div>
                              <CButton
                                @click="previewTemplate(item)"
                                class="preview-btn"
                              >
                                Preview Template
                              </CButton>
                            </div>
                            <CButton
                              class="save-btn"
                              @click="UpdateTemplate(index, item)"
                              >Update Template</CButton
                            >
                            <!-- <CButton
                              class="delete-btn"
                              @click="deleteTemplate()"
                              >Delete Template</CButton
                            > -->
                            <!-- <span v-html="item.MailBody"></span> -->
                          </div>
                        </CCol>
                        <CCol col="3">
                          <div class="tags-col-right">
                            <h5 class="col-black">Tags</h5>
                            <ul>
                              <li
                                v-for="(subItem, subindex) in item.EmailTags"
                                :key="subindex"
                              >
                                <a
                                  style="cursor: pointer"
                                  @dblclick="
                                    getTagsValue(subItem, $event, index)
                                  "
                                  >{{ "{" + "{" + subItem + "}" + "}" }}</a
                                >
                              </li>
                              <!-- <li><a href="#">added_datetime</a></li>
                              <li><a href="#">customer_name</a></li>
                              <li><a href="#">vehicle_name</a></li>
                              <li><a href="#">executive_name</a></li>
                              <li><a href="#">request_number_tag</a></li> -->
                            </ul>
                          </div>
                        </CCol>
                      </CRow>
                    </div>
                  </div>
                </div>
                <!-- <div
                  class="c-accordion__entry"
                  aria-expanded="false"
                  role="tablist"
                >
                  <div
                    id="c-accordion__entry-title-2"
                    class="c-accordion__entry-title"
                    aria-selected="false"
                    aria-controls="c-accordion__entry-body-2"
                    role="tab"
                  >
                    <CSwitch
                      class="ml-3"
                      :key="key"
                      :color="colors"
                      v-bind="modes"
                      checked
                      :value="color"
                      v-for="(color, key) in colors"
                    />
                    <a
                      href=""
                      class="
                        c-accordion__entry-header-link
                        js-accordion__entry-header-link
                      "
                    >
                      Add Lead Customer
                      <div class="c-accordion__entry-header-icon-wrapper">
                        <svg
                          class="c-accordion__entry-header-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="19.999"
                          height="12.979"
                          viewBox="0 0 19.999 12.979"
                        >
                          <path
                            d="M12,14.979l-10-10L4.979,2,12,9.021,19.02,2,22,4.979Z"
                            transform="translate(-2 -2)"
                            fill="#000"
                          ></path>
                        </svg>
                      </div>
                    </a>
                  </div>
                  <div
                    id="c-accordion__entry-body-2"
                    class="c-accordion__entry-body"
                    aria-hidden="true"
                    role="tabpanel"
                    aria-labelledby="c-accordion__entry-title-2"
                  >
                    <div class="c-accordion__entry-contents c-wysiwyg">
                      Text
                    </div>
                  </div>
                </div>
                <div
                  class="c-accordion__entry"
                  aria-expanded="false"
                  role="tablist"
                >
                  <div
                    id="c-accordion__entry-title-3"
                    class="c-accordion__entry-title"
                    aria-selected="false"
                    aria-controls="c-accordion__entry-body-3"
                    role="tab"
                  >
                    <CSwitch
                      class="ml-3"
                      :key="key"
                      :color="colors"
                      v-bind="modes"
                      checked
                      :value="color"
                      v-for="(color, key) in colors"
                    />
                    <a
                      href=""
                      class="
                        c-accordion__entry-header-link
                        js-accordion__entry-header-link
                      "
                    >
                      Waste Sample Collection Added
                      <div class="c-accordion__entry-header-icon-wrapper">
                        <svg
                          class="c-accordion__entry-header-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="19.999"
                          height="12.979"
                          viewBox="0 0 19.999 12.979"
                        >
                          <path
                            d="M12,14.979l-10-10L4.979,2,12,9.021,19.02,2,22,4.979Z"
                            transform="translate(-2 -2)"
                            fill="#000"
                          ></path>
                        </svg>
                      </div>
                    </a>
                  </div>
                  <div
                    id="c-accordion__entry-body-3"
                    class="c-accordion__entry-body"
                    aria-hidden="true"
                    role="tabpanel"
                    aria-labelledby="c-accordion__entry-title-3"
                  >
                    <div class="c-accordion__entry-contents c-wysiwyg">
                      Text
                    </div>
                  </div>
                </div>
                <div
                  class="c-accordion__entry"
                  aria-expanded="false"
                  role="tablist"
                >
                  <div
                    id="c-accordion__entry-title-4"
                    class="c-accordion__entry-title"
                    aria-selected="false"
                    aria-controls="c-accordion__entry-body-4"
                    role="tab"
                  >
                    <CSwitch
                      class="ml-3"
                      :key="key"
                      :color="colors"
                      v-bind="modes"
                      checked
                      :value="color"
                      v-for="(color, key) in colors"
                    />
                    <a
                      href=""
                      class="
                        c-accordion__entry-header-link
                        js-accordion__entry-header-link
                      "
                    >
                      Picking Waste
                      <div class="c-accordion__entry-header-icon-wrapper">
                        <svg
                          class="c-accordion__entry-header-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="19.999"
                          height="12.979"
                          viewBox="0 0 19.999 12.979"
                        >
                          <path
                            d="M12,14.979l-10-10L4.979,2,12,9.021,19.02,2,22,4.979Z"
                            transform="translate(-2 -2)"
                            fill="#000"
                          ></path>
                        </svg>
                      </div>
                    </a>
                  </div>
                  <div
                    id="c-accordion__entry-body-4"
                    class="c-accordion__entry-body"
                    aria-hidden="true"
                    role="tabpanel"
                    aria-labelledby="c-accordion__entry-title-4"
                  >
                    <div class="c-accordion__entry-contents c-wysiwyg">
                      Text
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
            <!-- <CPagination
              :activePage.sync="page"
              :pages="3"
              size="lg-5"
              align="left"
            /> -->
          </CCardBody>
        </CCard>
        <CModal
          color="danger"
          :title="modalTitle"
          :show.sync="warningModal"
          size="lg-2"
        >
          <span
            v-if="modalText"
            class="border rounded"
            v-html="modalText"
          ></span>
          <!-- {{modalText}} -->
        </CModal>
      </CCol>
    </CRow>
    <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      isLoading: true,
      emailItems: [],
      modes: [{ shape: "pill" }],
      colors: ["primary"],
      page: 2,
      warningModal: false,
      modalText: "",
      modalTitle: "",
      btn_status: "",
      finEmailBodyText: "",
      EmailSubjectLine_value: "",
      ToEmailAddress_value: "",
      seen: false,
    };
  },
  mounted() {
    this.getEmailItem();
  },
  methods: {
    onHideShow(indexVal) {
      let printicon = document.getElementById(
        "c-accordion__entry-body-" + parseInt(indexVal)
      );
      if (printicon.style.display != "block") {
        printicon.style.display = "block";
      } else {
        printicon.style.display = "none";
      }
    },

    enableDisableEmailTemplate(event, EmailTemplateId, ModuleId) {
      this.btn_status = event.target.checked;
      var token = localStorage.getItem("auth");
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));

      const self = this;
      var requestInfo = {
        EmailTemplateId: EmailTemplateId,
        ModuleId: ModuleId,
        Status: this.btn_status,
        Token: token,
        SessionUserId: Session_User_Id,
      };
      var data = JSON.stringify(requestInfo);
      const config = {
        method: "POST",
        url: apiURL + "ManageEmailTemplate/EnableDisableEmailTemplate",
        headers: { "Content-Type": "application/json" },
        data: data,
      };
      axios(config)
        .then((result) => {
          if (result.status == 200) {
            this.isLoading = false;
            this.getEmailItem();
            self.$swal.fire({
              icon: "success",
              title: "Done...",
              text: result.data.message,
            });
          } else {
            this.isLoading = false;
            self.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.message,
            });
          }
        })
        .catch(function (error) {
          this.isLoading = false;
          self.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },
    previewTemplate(templateHTML) {
      // alert(templateHTML);
      this.warningModal = true;
      this.modalText = templateHTML.MailBody;
      this.modalTitle = templateHTML.ModuleName;
    },
    getTagsValue(items, event, index) {
      // $(`#mailArea_${index}`).focus();
      // $(`#mailArea_${index}`).val(function () {
      //   return this.value + items;
      // });
      var txtarea = document.getElementById(`mailArea_${index}`);
      var start = txtarea.selectionStart;
      var end = txtarea.selectionEnd;
      var sel = txtarea.value.substring(start, end);
      this.finEmailBodyText =
        txtarea.value.substring(0, start) +
        "{{" +
        items +
        "}}" +
        txtarea.value.substring(end);
      txtarea.value = this.finEmailBodyText;
      // txtarea.focus();
      txtarea.selectionEnd = end + 7;
    },
    onChangeModule(event) {
      alert(event.target.value);
    },
    UpdateTemplate(index, templateDetails) {
      // alert(index);
      // console.log("templateDetails:", templateDetails);
      var token = localStorage.getItem("auth");
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
      var EmailSubjectLineVal = $("#EmailSubjectLine_" + index).val();
      var ToEmailAddressVal = $("#ToEmailAddress_" + index).val();
      var Main_Body = $("#mailArea_" + index).val();
      // console.log(Main_Body.replace(/"/g,'\\"'));

      this.finEmailBodyText = Main_Body;
      var requestInfo = {
        EmailTemplateId: templateDetails.EmailTemplateId,
        ModuleId: templateDetails.ModuleId,
        Status: templateDetails.Status,
        EmailSubjectLine: EmailSubjectLineVal,
        ToEmailAddress: ToEmailAddressVal,
        MailBody: this.finEmailBodyText
          ? this.finEmailBodyText
          : templateDetails.MailBody,
        Token: token,
        SessionUserId: Session_User_Id,
      };
      var self = this;
      // console.log("requestInfo:", requestInfo);
      var data = JSON.stringify(requestInfo);
      var config = {
        method: "post",
        url: apiURL + "ManageEmailTemplate/UpdateEmailTemplate",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((result) => {
          this.isLoading = false;
          //console.log(config);
          if (result.data.status_code == 200) {
            this.isLoading = false;
            this.getEmailItem();
            this.$swal.fire("Saved", result.data.message, "success");
            //$('.formData')[0].reset();
          } else {
            this.isLoading = false;
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.message,
            });
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },
    deleteTemplate() {
      alert("delete template!");
    },
    getEmailItem() {
      // debugger;

      // this.emailItems = {
      //   data: "true",
      //   status_code: "200",
      //   message: "Email templates detail retreived successfully",
      //   emailTemplateDataList: [
      //     {
      //       EmailTemplateId: 1,
      //       ModuleId: 9,
      //       ModuleName: "Add Waste",
      //       Status: true,
      //       MailBody: ` Lorem, ipsum dolor sit amet consectetur adipisicing
      //                       elit. Quidem mollitia animi, deleniti possimus
      //                       nesciunt eligendi soluta recusandae, repellat modi
      //                       ab sit facilis, voluptatum dolore veniam molestias
      //                       odit autem? Dolorem, est? Lorem ipsum dolor sit amet
      //                       consectetur adipisicing elit. Aliquam, a minus odio
      //                       numquam quidem veritatis reprehenderit officia nemo
      //                       nulla, quaerat temporibus necessitatibus vel sunt
      //                       esse ipsam aspernatur, consequatur porro molestias?`,
      //       EmailTags: [
      //         "waste_name",
      //         "added_datetime",
      //         "customer_name",
      //         "vehicle_name",
      //         "executive_name",
      //       ],
      //     },
      //      {
      //       EmailTemplateId: 2,
      //       ModuleId: 9,
      //       ModuleName: "Add Lead Customer",
      //       Status: true,
      //       MailBody: ` Lorem, ipsum dolor sit amet consectetur adipisicing
      //                       elit. Quidem mollitia animi, deleniti possimus
      //                       nesciunt eligendi soluta recusandae, repellat modi
      //                       ab sit facilis, voluptatum dolore veniam molestias
      //                       odit autem? Dolorem, est? Lorem ipsum dolor sit amet
      //                       consectetur adipisicing elit. Aliquam, a minus odio
      //                       numquam quidem veritatis reprehenderit officia nemo
      //                       nulla, quaerat temporibus necessitatibus vel sunt
      //                       esse ipsam aspernatur, consequatur porro molestias?`,
      //       EmailTags: [
      //         "waste_name",
      //         "added_datetime",
      //         "customer_name",
      //         "vehicle_name",
      //         "executive_name",
      //       ],
      //     },
      //    {
      //       EmailTemplateId: 3,
      //       ModuleId: 9,
      //       ModuleName: "Picking waste",
      //       Status: true,
      //       MailBody: ` Lorem, ipsum dolor sit amet consectetur adipisicing
      //                       elit. Quidem mollitia animi, deleniti possimus
      //                       nesciunt eligendi soluta recusandae, repellat modi
      //                       ab sit facilis, voluptatum dolore veniam molestias
      //                       odit autem? Dolorem, est? Lorem ipsum dolor sit amet
      //                       consectetur adipisicing elit. Aliquam, a minus odio
      //                       numquam quidem veritatis reprehenderit officia nemo
      //                       nulla, quaerat temporibus necessitatibus vel sunt
      //                       esse ipsam aspernatur, consequatur porro molestias?`,
      //       EmailTags: [
      //         "waste_name",
      //         "added_datetime",
      //         "customer_name",
      //         "vehicle_name",
      //         "executive_name",
      //       ],
      //     },
      //   ],
      // };
      var token = localStorage.getItem("auth");
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));

      const self = this;
      var requestInfo = {
        Token: token,
        SessionUserId: Session_User_Id,
      };
      var data = JSON.stringify(requestInfo);
      const config = {
        method: "POST",
        url: apiURL + "ManageEmailTemplate/GetAllEmailTemplates",
        headers: { "Content-Type": "application/json" },
        data: data,
      };
      // console.log(config);
      axios(config)
        .then((result) => {
          // console.log(result);
          if (result.status == 200) {
            this.isLoading = false;
            // console.log(result.data.emailTemplateDataList);
            this.emailItems = result.data.emailTemplateDataList;
            result.data.emailTemplateDataList.forEach((element) => {
              this.EmailSubjectLine_value = element.EmailSubjectLine;
              this.ToEmailAddress_value = element.ToEmailAddress;
            });
            // console.log(emailItems);
          } else {
            this.isLoading = false;
            self.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.message,
            });
          }
        })
        .catch(function (error) {
          this.isLoading = false;
          self.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },
  },
};
var MODULE = MODULE || {};

(function ($, MODULE) {
  MODULE.init_accordion = function () {
    // Logic for accordion
    var accordion = (function () {
      var $accordion_elem = $(".c-accordion"),
        $accordion_headerlink = $accordion_elem.find(
          ".js-accordion__entry-header-link"
        ),
        $accordion_item = $accordion_elem.find(".c-accordion__entry");

      var settings = {
        speed: parseInt($accordion_elem.attr("data-speed")) || 400,
        individual_openable:
          $accordion_elem.attr("data-individual-openable") === "true",
      };

      return {
        init: function () {
          $accordion_headerlink.on("click", function (e) {
            e.preventDefault();
            accordion.toggle($(this));
          });

          if (
            !settings.individual_openable &&
            $(".c-accordion__entry.is-expanded").length > 1
          ) {
            $(".c-accordion__entry.is-expanded").removeClass("is-expanded");
          }
        },
        toggle: function (self) {
          if (
            !settings.individual_openable &&
            self[0] !=
              self
                .closest(".c-accordion")
                .find(
                  ".c-accordion__entry.is-expanded .c-accordion__entry-header-link"
                )[0]
          ) {
            self
              .closest(".c-accordion")
              .find(".c-accordion__entry")
              .removeClass("is-expanded")
              .find(".c-accordion__entry-body")
              .slideUp();
          }

          self
            .closest(".c-accordion__entry")
            .toggleClass("is-expanded")
            .attr("aria-expanded", function (i, attr) {
              return attr == "true" ? "false" : "true";
            });

          self.parent().attr("aria-selected", function (i, attr) {
            return attr == "true" ? "false" : "true";
          });

          self
            .parent()
            .next()
            .stop()
            .slideToggle(settings.speed)
            .attr("aria-hidden", function (i, attr) {
              return attr == "true" ? "false" : "true";
            });
        },
      };
    })();

    accordion.init();
  };

  /* READY FUNCTION
  ====================== */

  $(function () {
    MODULE.init_accordion();
  });
})(jQuery, MODULE);
</script>
